<template>
  <div>
    <div style="font-size: 10px; width: 165px;" class="fontMono">
      <div>
        <div style="text-align: center;">
          <strong>{{dataprint.empresa.nombrec}}</strong>
          <br />
          {{dataprint.empresa.nombre}}
        </div>
        <div
          style="text-align: center;"
        >{{dataprint.empresa.nit | textnumber()}}{{dataprint.empresa.nit | dverif()}}</div>
        <div style="text-align: center;">Tel: {{dataprint.empresa.telefono}}</div>
        <div style="text-align: center;">{{dataprint.empresa.direccion}}</div>
        <div style="text-align: center;">{{dataprint.empresa.ciudad}}</div>
        <div style="text-align: center">{{dataprint.registros[0].fecha | date()}}</div>
        <div style="text-align: center">
          {{dataprint.comprobante.titulo ? dataprint.comprobante.titulo : dataprint.comprobante.nombre}}:
          {{dataprint.comprobante.prefijo}} {{dataprint.registros[0].documento}}
        </div>
        <div style="text-align: center">{{dataprint.comprobante.factura.resolucion}}</div>
        <div
          style="text-align: center"
        >Cliente: {{dataprint.registros[0].idnit.nombre}} {{dataprint.registros[0].idnit.codigo}}</div>

        <div style="text-align: center;">---------------------</div>
        <table style="font-size: 10px;">
          <tr v-for="(registro, index) in dataprint.registros" :key="index">
            <td>{{registro.producto.descripcion}} x {{registro.cantidad}}</td>
            <td
              style="text-align: right;"
            >{{registro.valor*(100+registro.datosFactura.impuesto)/100 | number(2)}}</td>
          </tr>
          <tr>
            <td colspan="2">
              <div style="text-align: center;">---------------------</div>
            </td>
          </tr>
          <tr>
            <td>Sub Total</td>
            <td style="text-align: right;">{{dataprint.totales.subtotal | number(2)}}</td>
          </tr>
          <tr v-show="dataprint.totales.iva > 0">
            <td>Iva</td>
            <td style="text-align: right;">{{dataprint.totales.iva | number(2)}}</td>
          </tr>
          <tr style="font-size: 12px">
            <td>
              <strong>Total</strong>
            </td>
            <td style="text-align: right;">
              <strong>{{dataprint.totales.total | number(2)}}</strong>
            </td>
          </tr>
        </table>
        <div v-show="dataprint.incluircambio">
          <div style="text-align: center;">---------------------</div>
          <div style="text-align: center;">---------------------</div>
          <table style="font-size: 10px;">
            <tr style="font-size: 12px">
              <td>Cambio:</td>
              <td
                style="text-align: right;"
              >{{dataprint.registros[0].datosFactura.cambio | number(2)}}</td>
            </tr>
          </table>
          <div style="text-align: center;">---------------------</div>
        </div>
      </div>
      <div style="text-align: center;">---------------------</div>
      <div style="text-align: center;">{{dataprint.comprobante.factura.piefactura}}</div>
      <div style="text-align: center;">{{dataprint.comprobante.factura.negrita}}</div>
      <div style="text-align: center;">{{dataprint.comprobante.factura.mensajefinal}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataprint: {
      type: Object,
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/prints/Frapvtastrip.vue